/* eslint-disable no-undef */
//import { isInViewport } from '../../../src/js/theme/main';

(function ($) {
	$.fn.memberCard = function () {
		let $el;
		// let $header;
		let $image;
		let $content;
		let $button;
		let $close;
		let $artifact = null;

		const init = function () {
			// $header = $el.find('.' + $el.attr('class').split(' ')[0] + '__header');
			$content = $el.find(
				'.' + $el.attr('class').split(' ')[0] + '__content'
			);
			$image = $el.find(
				'.' + $el.attr('class').split(' ')[0] + '__image'
			);
			$button = $el.find(
				'.' + $el.attr('class').split(' ')[0] + '__button'
			);
			$close = $el.find('.js-close-member-card');

			// Reveal on init if needed.
			reveal();

			// Scroll listener.
			$(window).scroll(function () {
				reveal();
			});

			$image.on('click', function () {
				if (!$el.hasClass('is-opened') && $content.length) {
					open();
				}
			});

			$button.on('click', function () {
				if (!$el.hasClass('is-opened') && $content.length) {
					open();
				}
			});

			$close.on('click', function (e) {
				e.preventDefault();
				close();
			});
		};

		const reveal = function () {
			if (isInViewport($el)) {
				$el.addClass('is-visible');
			}
		};

		const open = function () {
			// Lock body.
			$('body').css({
				overflowY: 'hidden',
			});

			/**
			 * We're making the card position: fixed
			 * so we need to create an artifact to fill up the
			 * void it leaves behind to avoid the page jump.
			 */
			if ($artifact === null) {
				const $parent = $el.parent();
				$artifact = $('<div></div>');
				$el.parent().css('position', 'relative');
				$artifact.css({
					width: $parent.width(),
					height: $parent.height(),
					position: 'absolute',
				});
				$parent.prepend($artifact);
			}

			/**
			 * We also want to add the "curtain" object.
			 * It helps to hide the ugly in prepration for the final reveal.
			 * ... and it looks cool :)
			 */
			const $curtain = $('<div class="member-card__curtain"></div>');
			$curtain.insertAfter($el);
			$curtain.one(
				'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
				function () {
					$curtain.remove();
				}
			);

			/**
			 * While the curtain is on, prepare the person in the background.
			 */
			$el.delay(500).queue(function (next) {
				$el.addClass('is-opened');
				next();
			});

			$el.addClass('is-loaded');
		};

		const close = function () {
			$el.removeClass('is-opened');

			$('body').css({
				overflowY: 'auto',
			});

			$artifact.remove();
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).memberCard();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.member-card').memberCard();
	});
})(jQuery);
